import { defineMessages, useIntl } from 'react-intl'
import { FormControl, Switch, FormLabel, Box, Flex, Icon } from '@homebotapp/hb-react-component-catalog'
import { AssumablesLearnMoreModal } from '../../AssumablesLearnMoreModal/AssumablesLearnMoreModal'
import { selectCustomerProfile } from '../../../../store/selectors/customerProfile'
import { useSelector } from 'react-redux'

export const MSG = defineMessages({
  assumableToggle: {
    id: 'estimatedMonthlyPayment.assumableToggle',
    defaultMessage: 'Include assumable loan'
  },
  info: {
    id: 'estimatedMonthlyPayment.info',
    defaultMessage: 'info'
  }
})

export interface AssumableSwitchProps {
  isAssumable: boolean
  assumableToggle?: boolean
  buyDownToggle?: boolean
  setBuyDownToggle?: (value: boolean) => void
  setAssumableToggle?: (value: boolean) => void
}

export const AssumablePaymentToggle = ({
  isAssumable,
  assumableToggle,
  setAssumableToggle,
  setBuyDownToggle
}: AssumableSwitchProps) => {
  const intl = useIntl()
  const cp = useSelector(selectCustomerProfile)

  if (!cp?.assumableMortgagesEnabled) {
    return null
  }

  const handleAssumableToggle = (checked: boolean) => {
    setAssumableToggle && setAssumableToggle(checked)

    setBuyDownToggle(false)
  }

  return (
    <>
      {isAssumable && (
        <Box
          alignItems='center'
          display='flex'
          borderColor={'neutral.300'}
          borderRadius={5}
          paddingTop={0.5}
          borderWidth={[0.5, 0, 0]}
          justifyContent='center'
          width={'100%'}
          mb={4}
        >
          <Flex>
            <FormControl flexDir={'row'} display={'flex'} width='unset'>
              <Switch
                id='assumableSwitch'
                name='assumableSwitch'
                isChecked={assumableToggle}
                size={'sm'}
                marginTop={1}
                onChange={e => handleAssumableToggle(e.target.checked)}
                tracking={{
                  guid: 'dgck1FLxDoVmr1CsyAsqH1',
                  ui_context: 'Listing details',
                  descriptor: 'Toggled assumable switch for monthly payment details'
                }}
              />
              <FormLabel htmlFor='assumableSwitch' marginBottom='0' marginLeft={2} marginRight={1}>
                {intl.formatMessage(MSG.assumableToggle)}
              </FormLabel>
            </FormControl>
            <AssumablesLearnMoreModal
              buttonProps={{
                variant: 'ghost',
                colorScheme: 'primary',
                leftIcon: <Icon mr={-1} height={4} name='question-circle' />,
                size: 'xs',
                copy: intl.formatMessage(MSG.info),
                tracking: {
                  guid: 'xiZjp3xrD4ZHgLChjD8H2Z',
                  ui_context: 'Listing Details, assumable payment information toggle',
                  descriptor: 'Info button to learn more about assumables'
                }
              }}
            />
          </Flex>
        </Box>
      )}
    </>
  )
}
